// // ///frontend/components/config.js

// export const API = process.env.REACT_APP_API_URL || "http://localhost:5001/api";
// export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || "http://localhost:5001";
// export const UPLOADS_URL = process.env.REACT_APP_UPLOADS_URL || "http://localhost:5001/uploads";



//

// frontend/components/config.js

const isLocalhost =
  window.location.hostname === "localhost";

export const API = isLocalhost
  ? "http://localhost:5001/api"
  : "https://barzillay.com/api";

export const SOCKET_URL = isLocalhost
  ? "http://localhost:5001"
  : "https://barzillay.com";

export const UPLOADS_URL = isLocalhost
  ? "http://localhost:5001/uploads"
  : "https://barzillay.com/uploads";